import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=6b6ed1c5"
import script from "./AddressInput.vue?vue&type=script&lang=js"
export * from "./AddressInput.vue?vue&type=script&lang=js"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=6b6ed1c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports